import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import ProductBanListContainer from '../../containers/product/ProductBanListContainer';
import { PRODUCT_PAGE_NAME } from '../../constants/service/app/productConstants';

const ProductBanList = () => {
  return (
    <PageTemplate pageName={PRODUCT_PAGE_NAME.PRODUCT_BAN_LIST}>
      <ProductBanListContainer pageName={PRODUCT_PAGE_NAME.PRODUCT_BAN_LIST} />
    </PageTemplate>
  );
};

export default ProductBanList;
